import { withStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PF2MCustomDragLayer from '~/components/PF2MCustomDragLayer';
import PF2MTabs from '~/components/PF2MTabs';
import AllocationsTab from './AllocationsTab';
import AllocationsTabV2 from './AllocationsTabV2';
import BlackListAllocationsTab from './BlackListAllocationsTab';
import styles from './styles';
import AllocationsEditTabs from './AllocationsEditTabs';
import useTabletConfiguration from '~/services/tabletConfiguration';

const LoadSchedules = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { t: translate } = useTranslation();
  const { value: dispatchRealTime } = useTabletConfiguration('dispatch_real_time');

  const tabs = [
    { key: 0, label: translate('common:Allocation') },
    { key: 1, label: translate('common:Restriction') },
    { key: 2, label: translate('common:AllocationEdit') },
  ];

  const handleChange = (event, value) => {
    setSelectedTab(value);
  };

  return (
    <>
      <PF2MTabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        hideSyncButton
      >
        {tabs}
      </PF2MTabs>
      {selectedTab === 0 ? (
        <>
          {dispatchRealTime === '1' ? <AllocationsTabV2 /> : <AllocationsTab />}
          <PF2MCustomDragLayer />
        </>
      ) : null}
      {selectedTab === 1 ? (<BlackListAllocationsTab />) : null}
      {selectedTab === 2 ? (<AllocationsEditTabs />) : null}
    </>
  );
};

export default withStyles(styles)(LoadSchedules);
